<template>
  <div
    @click="$emit('click', prospect)"
    :class="[
      'bg-white dark:bg-gray-800 overflow-hidden shadow dark:shadow-gray-900/50 rounded-lg hover:shadow-lg transition-shadow cursor-pointer border-l-4',
      borderColor,
      cardClass
    ]"
  >
    <div class="p-5">
      <!-- Top row: badges -->
      <div class="flex items-center justify-between mb-2">
        <div class="flex items-center gap-2">
          <span v-if="badge" :class="['text-xs font-medium px-2 py-1 rounded', badgeClass]">
            {{ badge }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <slot name="badge-extra"></slot>
          <span
            v-if="statusBadge"
            :class="['text-xs font-medium px-2 py-1 rounded', statusBadgeClass]"
          >
            {{ statusBadge }}
          </span>
        </div>
      </div>

      <!-- Subject -->
      <h3 class="text-base font-medium text-gray-900 dark:text-white truncate mb-1">
        {{ prospect.subject }}
      </h3>

      <!-- Organization -->
      <p class="text-xs text-gray-600 dark:text-gray-400 mb-2">
        {{ prospect.organization_name || 'Geen organisatie' }}
      </p>

      <!-- Optional extra info slot -->
      <slot name="info"></slot>

      <!-- Date and Revenue row -->
      <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mt-2">
        <span v-if="showPeriod">
          {{ formatDate(prospect.start_date) }} - {{ formatDate(prospect.expected_closing_date) }}
        </span>
        <span v-if="showRevenue && prospect.expected_revenue">
          &euro;{{ formatCurrency(prospect.expected_revenue) }}
          <span v-if="prospect.chance_to_score">({{ prospect.chance_to_score }}%)</span>
        </span>
      </div>

      <!-- Footer slot (for submission info etc.) -->
      <div v-if="$slots.footer" class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  prospect: {
    type: Object,
    required: true
  },
  badge: {
    type: String,
    default: null
  },
  badgeClass: {
    type: String,
    default: 'bg-blue-100 text-blue-700'
  },
  statusBadge: {
    type: String,
    default: null
  },
  statusBadgeClass: {
    type: String,
    default: 'bg-gray-100 text-gray-600'
  },
  borderColor: {
    type: String,
    default: 'border-gray-300'
  },
  showPeriod: {
    type: Boolean,
    default: true
  },
  showRevenue: {
    type: Boolean,
    default: true
  },
  cardClass: {
    type: String,
    default: ''
  }
})

defineEmits(['click'])

function formatDate(dateString) {
  if (!dateString) return ''
  return new Date(dateString).toLocaleDateString('nl-NL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

function formatCurrency(amount) {
  if (!amount) return '0'
  return new Intl.NumberFormat('nl-NL').format(amount)
}
</script>
